import React, { useCallback, useState } from 'react';
import Icon from '../utils/Icon';
import Ripple from '../utils/Ripple';
import useHelpNoteTitle from '../utils/Translations/useHelpNoteTitle';
import useT from '../utils/Translations/useT';
const ApplyFilterButton = ({ className, onClick, dataCy, }) => {
    const t = useT();
    const title = t('Apply Filters');
    const tooltipTitle = useHelpNoteTitle(title);
    const [hovered, setHovered] = useState(false);
    const handleMouseEnter = useCallback(() => {
        setHovered(true);
    }, []);
    const handleMouseLeave = () => {
        setHovered(false);
    };
    return (<li className={className} data-cy={dataCy} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <Ripple>
        <a className="text-center legitRipple collapsed" data-cy={dataCy ? `${dataCy}-button` : undefined} title={tooltipTitle} onClick={onClick}>
          {hovered ? (<Icon src="/images/filter-check-black.svg" type="image"/>) : (<Icon src="/images/filter-check.svg" type="image"/>)}
        </a>
      </Ripple>
    </li>);
};
export default ApplyFilterButton;
